//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_pi = 3.141592653589793;\n\
";
